import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { BASE_CLASSNAME } from './Constants';
import { createIconTextBannerComponent } from './IconTextBanner';
createComponents(".".concat(BASE_CLASSNAME), createIconTextBannerComponent, NO_PATTERN_BUSINESS_LOGIC);
